
import Cookies from 'js-cookie'

function getDomain (url) {
  const array = url.split('.')
  const length = array.length

  return `.${array[length - 2]}.${array[length - 1]}`
}

// const log = window.console.log
// window.console.log = function () {
//   if (process.env.NODE_ENV === 'production') {
//     return storage.log('log', ...arguments)
//   }
//   log.apply(this, arguments)
// }

export const storage = {
  set (key, data) {
    if (!data && data !== 0) return
    if (typeof data === 'string') {
      localStorage.setItem(key, data)
    } else {
      localStorage.setItem(key, JSON.stringify(data))
    }
  },
  get (key) {
    const str = localStorage.getItem(key)
    let val
    try {
      val = JSON.parse(str)
    } catch (e) {
      val = str
    }
    return val
  },
  remove (key) {
    localStorage.removeItem(key)
  },
  // 是否登录
  isLogined () {
    return !!Cookies.get('userToken')
  },
  getToken () {
    return Cookies.get('userToken')
  },
  // token有效期控制30天
  setToken (token) {
    const domain =  getDomain(location.host)
    console.log('---存储登录态', domain)
    Cookies.set('userToken', token, { expires: 30 })
    Cookies.set('__wykjt__', token, {
      domain,
      path: '/',
      expires: 30
    })
  },
  // 退出登录 销毁数据
  logout (key) {
    Cookies.remove('userToken')
    Cookies.remove('__wykjt__')
    localStorage.removeItem('loginPhone')
    localStorage.removeItem('userData')
    localStorage.removeItem('prodCode')
  },
  // 清除所有数据（包括entranceData、token...）
  clear () {
    Cookies.remove('userToken')
    Cookies.remove('__wykjt__')
    localStorage.clear()
  },
  setChannel (e) {
    e && localStorage.setItem('channel', e)
  },
  getChannel () {
    return localStorage.getItem('channel') || 'hy'
  },
  log (consoleName, ...value) {
    if (value && value.length > 0) {
      if (consoleName === 'log') {
        consoleName = '::'
      }
      value = value.reduce((pre, cur) => {
        if (typeof cur !== 'string') {
          try {
            cur = JSON.stringify(cur)
          } catch (e) {
            cur = '---------'
          }
        }
        return pre + cur
      }, '')
      if (consoleName) {
        const objs = {
          consoleName, value, time: new Date().toLocaleString()
        }
        if (!window.__log__) {
          window.__log__ = [objs]
        } else {
          window.__log__ = [objs, ...window.__log__.slice(0, 20)]
        }
      }
    }
    return window.__log__ || []
  },
  logClear () {
    window.__log__ = []
  }
}



// WEBPACK FOOTER //
// ./src/store/local.js